import { useMemo, useState } from "react";
import { DropdownMenu, DropdownMenuItem } from "../DropdownMenu";
import { Colors } from "../../utils/colors";
import { ThemeType } from "@markit/common.types";
import { useTheme } from "../../hooks/useTheme";
import DropdownArrowIcon from "../DropdownsAndTabs/DropdownArrowIcon";

export enum DataQuestionFilterType {
  ANY_TYPE = "Any Type",
  SHORT_ANSWER = "Short Answer",
  MULTIPLE_CHOICE = "Multiple Choice",
  CHECKBOX = "Checkbox",
  EMAIL = "Email",
  FILE_UPLOAD = "File Upload",
}

type SavedQuestionTypeDropdownProps = {
  selectedType: DataQuestionFilterType;
  setSelectedType: (type: DataQuestionFilterType) => void;
  themeType?: ThemeType;
};

const SavedQuestionTypeDropdown = (props: SavedQuestionTypeDropdownProps) => {
  const { selectedType, setSelectedType, themeType } = props;
  const { theme } = useTheme(themeType);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const styles = {
    filterContainer: {
      gap: 10,
      borderRadius: 10,
      paddingInline: 14,
      paddingBlock: 12,
      backgroundColor: theme
        ? theme.NewPrimaryBG.backgroundColor
        : Colors.WHITE1,
      border: `0.5px solid ${Colors.GRAY2}`,
    },
  };

  const dropdownItems: DropdownMenuItem[] = useMemo(
    () => [
      {
        title: DataQuestionFilterType.ANY_TYPE,
        icon: "ion:albums",
        key: "all_questions",
        onPress: () => setSelectedType(DataQuestionFilterType.ANY_TYPE),
      },
      {
        title: DataQuestionFilterType.SHORT_ANSWER,
        icon: "mdi:text-box",
        key: "short_answer",
        onPress: () => setSelectedType(DataQuestionFilterType.SHORT_ANSWER),
      },
      {
        title: DataQuestionFilterType.MULTIPLE_CHOICE,
        icon: "mdi:circle-multiple",
        key: "multiple_choice",
        onPress: () => setSelectedType(DataQuestionFilterType.MULTIPLE_CHOICE),
      },
      {
        title: DataQuestionFilterType.CHECKBOX,
        icon: "mdi:checkbox-multiple-marked",
        key: "checkbox",
        onPress: () => setSelectedType(DataQuestionFilterType.CHECKBOX),
      },
      {
        title: DataQuestionFilterType.FILE_UPLOAD,
        icon: "ion:document",
        key: "file_upload",
        onPress: () => setSelectedType(DataQuestionFilterType.FILE_UPLOAD),
      },
      {
        title: DataQuestionFilterType.EMAIL,
        icon: "ion:mail",
        key: "email",
        onPress: () => setSelectedType(DataQuestionFilterType.EMAIL),
      },
    ],
    [setSelectedType]
  );

  return (
    <DropdownMenu
      dropdownItems={dropdownItems}
      trigger={["click"]}
      placement="bottomLeft"
      onOpenChange={(isOpen: boolean) => setDropdownVisible(isOpen)}
      altWidth={160}
      dark={themeType === ThemeType.Dark}
    >
      <div className="AlignedRowSelect" style={{ ...styles.filterContainer }}>
        <span
          className="bodyMedium"
          style={{ ...theme?.PrimaryText, whiteSpace: "nowrap" }}
        >
          {selectedType}
        </span>
        <DropdownArrowIcon
          isOpen={dropdownVisible}
          height={14}
          color={theme?.PrimaryText?.color}
        />
      </div>
    </DropdownMenu>
  );
};

export default SavedQuestionTypeDropdown;
